<template>
  <div>
    <div class="searchContent">
      <div class="search-left" v-if="showMenu">
        <div class="search-havtitle">
          信息导航
        </div>
        <div class="scrollbar">
          <ul class="ul-data">
            <li v-if="item.length<=1" class="li-data" :data-id="item[0].split('_')[0]"
                v-for="(item) in countType">
              <span @click="getAllData" :title="item[0].split('_')[1]">{{ item[0].split('_')[1] }}</span>
            </li>
            <li v-if="item.length>1" class="li-data"
                :data-id="item[0].split('_')[0]"
                v-for="(item,index) in countType">
              <span :title="item[0].split('_')[1]" @click="hideClick(index)">{{ item[0].split('_')[1] }}
              <img v-if="!(index==nowIndex&&shouChild)" style="margin-left: 5px;"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAATklEQVQImW2OwQ2AMAwDr4iNsgpT0M0okwFDoKsEgip+JfLFTomIBizk2idgBY7Ev4AqcDokQD8U6FHA9jHdreYBlClW/RLnodPY8v4E3N3iD0AgqqtOAAAAAElFTkSuQmCC">
              <img v-else style="margin-left: 5px;"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAWElEQVQImWM07vjPgARCGBgY/jEwMKyDibEgSYoyMDBMhbIPMTAwvAExmJAUTGNgYBCD4skwQZgCkNEgDAMRMD5IAUgHSDc6AFknAlIAYoDsRwdiDAwMUwFfDgtzbkicEwAAAABJRU5ErkJggg==">
              </span>
              <ol v-show="index==nowIndex&&shouChild"
                  v-for="(i) in item.slice(1)"
                  class="ol-data">
                <li v-if="i!=null" :data-id="i.split('_')[0]">
                  <span :style="{color:(i.split('_')[0]===sjType?'#3388FF':'#595959')}"
                        @click="getDataByType(i.split('_')[0])" :title="i.split('_')[2]">{{ i.split('_')[2] }}</span>
                </li>
              </ol>
            </li>
          </ul>
        </div>
      </div>
      <div class="search-right">
        <input v-model="keyword" type="text" autocomplete="off" placeholder="企业法定全称" maxlength="50"
               class="search-txt">
        <span class="search-query-btn" @click="searchQuery">查询</span>

        <div style="margin-top: 10px;">
          <div style="margin-bottom: 10px;">
            <a style="color: #3388ff;" @click="sjbg">数据报告</a>
          </div>
          <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="mid"
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
<!--                <a @click="deatils(record.mid)">查看</a>-->
                <router-link tag="a" target="_blank" :to="{path:`/details/${record.mid}`}">查看</router-link>
              </span>
          </a-table>
        </div>
        <a-modal
            title="充值提醒"
            :visible="visible"
            :footer="false"
            @cancel="handleCancel">
          <p>您的余额不足，是否<a style="color: #1977f5" @click="toCz">前往充值？</a></p>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import {getAction} from "@/api/manage";
import Vue from 'vue'
import {ACCESS_TOKEN} from "@/store/mutation-types";

export default {
  name: "Search",
  data() {
    return {
      keyword: '',
      dataSource: [],
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: '7%',
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '名称',
          dataIndex: 'oname',
          width: '25%',
          ellipsis: true,
        },
        {
          title: '处罚结果',
          dataIndex: 'cf_cflb',
          width: '15%',
          ellipsis: true,
        },
        {
          title: '处罚机关',
          dataIndex: 'cf_xzjg',
          width: '25%',
          ellipsis: true,
        },
        {
          title: '时间',
          dataIndex: 'cf_jdrq',
          width: '15%',
          ellipsis: true,
        },
        {
          title: '详情',
          dataIndex: 'action',
          align: "center",
          width: '10%',
          scopedSlots: {customRender: 'action'}
        }
      ],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10'],
        showTotal: (total, range) => {
          return "第" + range[0] + "至" + range[1] + "条,共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false,
      queryParam: {},
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      countType: [],
      nowIndex: -1,
      nowChildIndex: -1,
      shouChild: false,
      sjType: '',
      url:{
        searchUrl:'/search/query'
      },
      showMenu:false,
      visible:false
    }
  },
  created() {
    if(!Vue.ls.get(ACCESS_TOKEN)){
      this.$router.push('/login');
    }
    if (this.$route.params.keyword) {
      this.keyword = this.$route.params.keyword
      this.getData();
    }
  },
  methods: {
    handleCancel(e) {
      this.visible = false;
    },
    toCz(){
      this.$router.push('/pay')
      this.visible = false;
    },
    sjbg(){
      // this.$router.push('/report')
      if(this.keyword==''){
        this.$message.warning('请输入企业法定全称！')
        return;
      }
      this.$router.push({name: 'report', params: {keyword: this.keyword}});
    },
    hideClick(index) {
      if (this.nowIndex == index && this.shouChild) {
        this.shouChild = false;
      } else {
        this.shouChild = true;
      }
      this.nowIndex = index;
    },
    getDataByType(type) {
      this.sjType = type;
      this.getData(1)
    },
    getAllData() {
      this.sjType = '';
      this.getData(1)
    },
    deatils(id) {
      this.$router.push(`/details/${id}`);
    },
    searchQuery() {
      if (this.keyword == '') {
        this.$message.warning('请输入企业法定全称！')
        return;
      }
      if (this.keyword .length<2) {
        this.$message.warning('关键字不能小于2个字！')
        return;
      }

      if (!Vue.ls.get(ACCESS_TOKEN)) {
        this.$message.error('请登录后查询！')
        return;
      }
      this.sjType=''
      this.getData(1)
    },
    formatKeyword(value){
      return value.replace(/[&\|\\\*^%$'"#@?]/g,'').trim();
    },
    getData(arg) {
      this.keyword = this.formatKeyword(this.keyword)
      this.showMenu = true;
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var param = {};
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      param.keyword = this.keyword;
      if (this.sjType != '') {
        param.sjType = this.sjType;
      }

      this.loading = true;
      getAction(this.url.searchUrl, param).then(res => {
        if (res.code==200) {
          this.loading = false;
          this.dataSource = res.data.rows;
          this.ipagination.total = res.data.total;
          if (res.data.countType != null) {
            this.countType = res.data.countType;
          }
        } else if(res.code==1007){
          this.loading = false;
          this.visible = true;
        }else {
          this.loading = false;
          this.$message.error(res.message)
        }

      })
    },
    handleTableChange(pagination, filters, sorter) {
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.getData()
    },
  }
}
</script>

<style scoped>
.searchContent {
  width: 1200px;
  margin: 20px auto;
  background: #FFFFFF;
  min-height: calc(100vh - 240px);
  position: relative;
  height: 750px;
}

.search-left {
  width: 160px;
  height: 650px;
  border: 1px solid #cccccc;
  position: absolute;
  top: 20px;
  left: 20px;
}

.scrollbar {
  width: 160px;
  height: 600px;
  overflow: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: hidden;
  overflow-y: auto;
}

.scrollbar::-webkit-scrollbar {
  display: none;
}

.ul-data {
  font-size: 15px;
}

.li-data {
  cursor: pointer;
  border-bottom: 1px solid #cccccc;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
}

.ol-data {
  margin-left: 20px;
  margin-bottom: 10px;
  margin-top: 10px
}

.search-right {
  width: 950px;
  height: 500px;
  position: absolute;
  top: 20px;
  left: 230px;
}

.search-havtitle {
  width: 158px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  background-color: #014298;
  color: #FFFFFF;
  text-align: center
}

.search-query-btn {
  cursor: pointer;
  width: 100px;
  color: white;
  font-size: 20px;
  background-color: #014298;
  padding: 7px 40px 9px 40px;
}

.search-txt {
  -webkit-appearance: none;
  background-color: #fff;
  border-radius: 4px 0px 0px 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  height: 42px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 85%;
  background-image: none;
  font-size: 16px;
  font-weight: 600;
}
</style>
